// Transactions API endpoints (Cash Sales, Invoices, Credit Notes, Refunds)

import apiClient from './client';
import { quotesAPI } from './quotes';

// Cash Sales
export const cashSalesAPI = {
  getAll: () => apiClient.get('/cashsales'),
  getById: (id) => apiClient.get(`/cashsales/${id}`),
  create: (data) => apiClient.post('/cashsales', data),
  update: (id, data) => apiClient.patch(`/cashsales/${id}`, data),
  delete: (id) => apiClient.delete(`/cashsales/${id}`),
  downloadPDF: (id) => apiClient.get(`/cashsales/${id}/pdf`, {
    responseType: 'blob'
  })
};

// Invoices
export const invoicesAPI = {
  getAll: () => apiClient.get('/invoices'),
  getById: (id) => apiClient.get(`/invoices/${id}`),
  create: (data) => apiClient.post('/invoices', data),
  update: (id, data) => apiClient.patch(`/invoices/${id}`, data),
  delete: (id) => apiClient.delete(`/invoices/${id}`),
  downloadPDF: (id) => apiClient.get(`/invoices/${id}/pdf`, {
    responseType: 'blob'
  })
};

// Credit Notes
export const creditNotesAPI = {
  getAll: () => apiClient.get('/creditnotes'),
  getById: (id) => apiClient.get(`/creditnotes/${id}`),
  create: (data) => apiClient.post('/creditnotes', data),
  update: (id, data) => apiClient.patch(`/creditnotes/${id}`, data),
  delete: (id) => apiClient.delete(`/creditnotes/${id}`),
  downloadPDF: (id) => apiClient.get(`/creditnotes/${id}/pdf`, {
    responseType: 'blob'
  })
};

// Refunds
export const refundsAPI = {
  getAll: () => apiClient.get('/refunds'),
  getById: (id) => apiClient.get(`/refunds/${id}`),
  create: (data) => apiClient.post('/refunds', data),
  update: (id, data) => apiClient.patch(`/refunds/${id}`, data),
  delete: (id) => apiClient.delete(`/refunds/${id}`),
  downloadPDF: (id) => apiClient.get(`/refunds/${id}/pdf`, {
    responseType: 'blob'
  })
};

// Generic transaction helper
export const getTransactionAPI = (type) => {
  switch (type) {
    case 'cash_sale':
      return cashSalesAPI;
    case 'invoice':
      return invoicesAPI;
    case 'credit_note':
      return creditNotesAPI;
    case 'refund':
      return refundsAPI;
    case 'quote':
      return quotesAPI;
    default:
      throw new Error(`Unknown transaction type: ${type}`);
  }
};
